import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown, IconText} from '@/web-components';

export const IconDropdown = ({
	options,
	emphasizeEmptyState,
	dropdownAlignment,
	selectedItems,
	width,
	name,
	selectedGroupName,
	optionsName,
	onSelect,
	onRemove,
	userpilot,
	headerLines,
}) => {
	const getSearchString = option => {
		return option.label.toLowerCase();
	};

	return (
		<Dropdown
			isNested
			isMultiSelect
			headerLines={headerLines}
			selectedItems={selectedItems}
			selectedGroupName={selectedGroupName}
			width={width}
			dropdownAlignment={dropdownAlignment}
			name={name}
			onSelect={onSelect}
			onRemove={onRemove}
			userpilot={userpilot}
			emphasizeEmptyState={emphasizeEmptyState}
		>
			<Dropdown.Group name={optionsName} key={'icon-dropdown-options'}>
				{options.map(option => {
					return (
						<IconText
							key={option.value}
							value={option.value}
							searchString={getSearchString(option)}
							text={option.label}
						>
							{option.icon}
						</IconText>
					);
				})}
			</Dropdown.Group>
		</Dropdown>
	);
};

IconDropdown.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any.isRequired,
			label: PropTypes.string.isRequired,
			icon: PropTypes.node.isRequired,
		})
	),
	dropDownAlignment: PropTypes.oneOf(['left', 'center', 'right']),
	width: PropTypes.number,
	name: PropTypes.string,
	optionsName: PropTypes.string,
	selectedItems: PropTypes.array,
	onSelect: PropTypes.func,
	onRemove: PropTypes.func,
	selectedGroupName: PropTypes.string,
	headerLines: PropTypes.element,
};

IconDropdown.defaultProps = {
	onSelect: () => false,
	onRemove: () => false,
};

export default IconDropdown;
